export default {
  routes: [{
    path: '/login',
    name: 'login',
    component: () => import('./views/LoginForm.vue'),
  },
  {
    path: '/login/acesso/:method?',
    name: 'sign-in',
    component: () => import('./views/LoginForm.vue'),
  }, {
    path: '/login/verificacao',
    name: 'sign-up-application',
    component: () => import('./views/SignUp.vue'),
  }, {
    path: '/login/verificacao/aprovada',
    name: 'sign-up-application-success',
    component: () => import('./views/SignUpApplicationSuccess.vue'),
  }, {
    path: '/login/verificacao/negada',
    name: 'sign-up-application-failed',
    component: () => import('./views/ApplicationDenied.vue'),
  }, {
    path: '/login/error',
    name: 'login-error',
    component: () => import('@/views/Error.vue'),
  }],
  beforeEachRoute(to, from, next) {
    const publicLoginRoutes = [
      '/login/verificacao',
    ];

    if (
      from.path === '/'
      && to.path !== '/login'
      && !publicLoginRoutes.includes(to.path)
    ) {
      setTimeout(() => next('/login'), 10);
    } else {
      setTimeout(() => next(), 10);
    }
  },
};
